import AppAuthLogin from "@/app/auth/login/login.vue";
import { RouteOptions } from "../types";
const AppAuthRegister = () => import("@/app/auth/register/register.vue");
const AppRegisterSetupTotp = () => import("@/app/auth/register/register-setup-totp.vue");
const AppAuthForgotPassword = () => import("@/app/auth/reset-password/forgot-password.vue");
const AppAuthResetPassword = () => import("@/app/auth/reset-password/reset-password.vue");
const AppAuthConfirmMailLogin = () => import("@/app/auth/login/confirm-mail-login.vue");
const AppAuthConfirmTotpLogin = () => import("@/app/auth/login/confirm-totp-login.vue");
const AppSetupMfa = () => import("@/app/auth/setup-mfa/setup-mfa.vue");

const authRoutes: RouteOptions[] = [
  {
    name: "Login",
    path: "/login",
    component: AppAuthLogin,
  },
  {
    name: "ConfirmMailLogin",
    path: "/confirm-mail-login/:confirmKey",
    component: AppAuthConfirmMailLogin,
  },
  {
    name: "ConfirmTOTPLogin",
    path: "/confirm-totp-login/:confirmKey",
    component: AppAuthConfirmTotpLogin,
  },
  {
    name: "Register",
    path: "/register/:confirmKey",
    component: AppAuthRegister,
  },
  {
    name: "RegisterTOTP",
    path: "/register-totp/:confirmKey",
    component: AppRegisterSetupTotp,
  },
  {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: AppAuthForgotPassword,
  },
  {
    name: "ResetPassword",
    path: "/reset-password/:confirmKey",
    component: AppAuthResetPassword,
  },
  {
    name: "SetupMfa",
    path: "/setup-mfa/:confirmKey/:userId",
    component: AppSetupMfa,
  },
];

export default authRoutes;
